<!--
 * @description: 批量修改要求到货日期
 * @author: 06455
 * @date: 2023/12/15 11:04
-->
<template>
  <a-modal v-model="modal" title="要求到货日期" width="350px" :maskClosable="false">
    <a-form-model
      :model="formData"
      ref="form"
    >
      <a-form-model-item
        label="要求到货日期"
        :labelCol="{ style: 'width: 120;float:left' }"
        :wrapperCol="{ style:'width:calc(100% - 120px );float:left'}"
      >
        <a-date-picker v-model="formData.requireDeliveryDay" @change="changeDate" :disabled-date="disabledEndDate" />
      </a-form-model-item>
    </a-form-model>
    <template #footer>
      <a-space>
        <a-button :loading="loading" @click="modal=false;;$refs.form.resetFields();">取消</a-button>
        <a-button type="primary" @click="submit" :loading="loading">确定</a-button>
      </a-space>
    </template>
  </a-modal>
</template>

<script>
import {
  apiReceiptPlanUpdateBatch
} from '@/services/module/receiving-plan'
export default {
  name: "ReviewDateModal",
  data () {
    return {
      modal: false,
      formData: {
        requireDeliveryDay: ''
      },
      loading: false,
      selectedRows: []
    }
  },
  methods: {
    show (selectedRows) {
      this.modal = true
      this.selectedRows = selectedRows
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;
          const rows = this.selectedRows.map((item) => {
            return {
              ...item,
              requireDeliveryDay: this.formData.requireDeliveryDay
            }
          })
          apiReceiptPlanUpdateBatch(rows).then(res => {
            this.modal = false
            this.$emit('submitSuccess')
            this.$message.success('修改成功')
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    // 修改到货日期
    changeDate (val) {
      this.formData.requireDeliveryDay = this.momentFun(val)
    },
    disabledEndDate (date) {
      return date && date.valueOf() < Date.now() - 86400000;
    }
  }
}
</script>

<style scoped>

</style>
